var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"w100p"},[(_vm.isLoading)?_c('v-progress-circular',{attrs:{"indeterminate":"","color":"primary"}}):_vm._e(),_c('canvas',{ref:"RenderCanvas",staticClass:"w100p",class:_vm.contentClass})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }